var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { TableViewData } from "./TableViewData";
import { useAsync2 } from "nate-react-api-helpers";
import { blankArray, pageSize } from "./TableViewSimple";
import { TableContext } from "./TableProvider";
import { downloadResultAsFile } from "./TableViewDataSimple";
import { jsx as _jsx } from "react/jsx-runtime";
export function TableViewDataAsync(props) {
    var _this = this;
    var _list$result, _list$result2, _list$result3;
    var tab = props.tab;
    var search = props.search;
    var _a = useState(0), page = _a[0], setPage = _a[1];
    var _b = useState(props.cols[0].name), orderBy = _b[0], setOrderBy = _b[1];
    var _c = useState("desc"), orderByDirection = _c[0], setOrderByDirection = _c[1];
    var orderByChange = useCallback(function (col, direction) { setOrderBy(col); setOrderByDirection(direction); }, []);
    var list = useAsync2(function (opts) { return props.fetcher(opts); }, { page: page, tab: tab || "", search: search || "", orderBy: orderBy, orderByDirection: orderByDirection, pageSize: pageSize }, [page, search, orderBy, tab, orderByDirection]);
    var reload = list.reload;
    var registerTable = useContext(TableContext).registerTable;
    var data = ((_list$result = list.result) === null || _list$result === void 0 ? void 0 : _list$result.data) || [];
    useEffect(function () { registerTable({ download: function (fileName) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            downloadResultAsFile(fileName, data, props.cols, false);
            return [2 /*return*/];
        }); }); }, reload: reload }); }, [registerTable, reload, data, props.cols]); // eslint-disable-next-line react-hooks/exhaustive-deps
    var navigateTo = useMemo(function () { return props.navigateTo; }, []);
    return /*#__PURE__*/ _jsx(TableViewData, { totalCount: ((_list$result2 = list.result) === null || _list$result2 === void 0 ? void 0 : _list$result2.totalCount) || 0, columns: props.cols, navigateTo: navigateTo, rows: ((_list$result3 = list.result) === null || _list$result3 === void 0 ? void 0 : _list$result3.data) || blankArray, loading: list.loading, error: list.error, onOrderByChange: orderByChange, orderBy: orderBy, orderByDirection: orderByDirection, onSelectionChanged: props.onSelectionChange, onPageChange: setPage, rowsPerPage: pageSize, page: page });
}
